import { useEffect } from "react"
import type { PageProps } from "gatsby"

import { navigateToSearchPage } from "~utils/navigation-helpers"

type Props = Pick<PageProps, "params">

// Originally state and country pages were statically generated, but now we have builder for SEO pages.
// This component helps us prevent old urls from breaking
export default function StateOutfitters({ params }: Props) {
    const state = params.state

    useEffect(() => {
        const searchQuery = `state=${state}`
        navigateToSearchPage(searchQuery)
    }, [])

    return null
}
